module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/post-template/post-template-create/post-template-create.component.css
// module id = ./src/app/components/post-template/post-template-create/post-template-create.component.css
// module chunks = main